<template>
    <ckeditor :editor="editor" :value="this.value" :config="editorConfig" @input="emit" @ready="onReady"></ckeditor>
</template>

<script>

const customColorPalette = [
    {
        color: 'rgb(0, 0, 0)',
        label: 'Black'
    },
    {
        color: 'rgb(77, 77, 77)',
        label: 'Dim grey'
    },
    {
        color: 'rgb(153, 153, 153)',
        label: 'Grey'
    },
    {
        color: 'rgb(230, 230, 230)',
        label: 'Light grey'
    },
    {
        color    : 'rgb(255, 255, 255)',
        label    : 'White',
        hasBorder: true
    },
    {
        color: 'rgb(230, 76, 76)',
        label: 'Red'
    },
    {
        color: 'rgb(230, 153, 76)',
        label: 'Orange'
    },
    {
        color: 'rgb(230, 230, 76)',
        label: 'Yellow'
    },
    {
        color: 'rgb(153, 230, 76)',
        label: 'Light green'
    },
    {
        color: 'rgb(76, 230, 76)',
        label: 'Green'
    },
    {
        color: 'rgb(76, 230, 153)',
        label: 'Aquamarine'
    },
    {
        color: 'rgb(76, 230, 230)',
        label: 'Turquoise'
    },
    {
        color: 'rgb(76, 153, 230)',
        label: 'Light blue'
    },
    {
        color: 'rgb(76, 76, 230)',
        label: 'Blue'
    },
    {
        color: 'rgb(153, 76, 230)',
        label: 'Purple'
    }
];

import CKEditor from '@ckeditor/ckeditor5-vue';

Vue.use(CKEditor);

export default {
    components: {
        ckeditor: CKEditor.component
    },
    name      : "ckeditor-container",
    props     : ['value', 'options', 'mentionFrom','placeholder'],
    data() {
        return {
            editor      : ClassicEditor,
            editorConfig: {
                placeholder        : this.placeholder || '',
                extraPlugins       : [this.mentionSelected],
                toolbar            : {
                    items: [
                        'heading',
                        '|',
                        'fontSize',
                        'fontFamily',
                        'fontColor',
                        'fontBackgroundColor',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'alignment',
                        'indent',
                        'outdent',
                        '|',
                        'imageUpload',
                        'blockQuote',
                        'insertTable',
                        'removeFormat',
                        'todoList',
                        'horizontalLine',
                        'pageBreak',
                        'undo',
                        'redo'
                    ]
                },
                language           : 'en',
                fontSize           : {
                    options: ['5px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
                },
                image              : {
                    toolbar: [
                        'imageTextAlternative',
                        'imageStyle:full',
                        'imageStyle:side'
                    ]
                },
                table              : {
                    contentToolbar     : [
                        'tableColumn',
                        'tableRow',
                        'mergeTableCells',
                        'tableCellProperties',
                        'tableProperties'
                    ],
                    tableProperties    : {
                        borderColors    : customColorPalette,
                        backgroundColors: customColorPalette
                    },
                    tableCellProperties: {
                        borderColors    : customColorPalette,
                        backgroundColors: customColorPalette
                    }
                },
                fontBackgroundColor: {
                    colors: customColorPalette
                },
                fontColor          : {
                    colors: customColorPalette
                },
                mention            : {
                    feeds: [
                        {
                            marker           : '@',
                            feed             : this.getFeedItems,
                            minimumCharacters: 1
                        }
                    ]
                }
            },
            userInput   : false,
            atValues    : this.options.map(this.mapValues),
            editorInstance: null,
        }
    },
    mounted() {
        // Bus.$on('mention', data => {
        //     this.$emit('mention', data);
        // });
    },
    watch     : {
        options() {
            this.atValues = this.options.map(this.mapValues);
        },
    },
    methods   : {
        emit(value, batch) {
            this.$emit('input', value);
        },
        onReady(editor) {
            window.editor = this.editor;
            this.editorInstance = editor;
        },
        getFeedItems(queryText) {
            let values = this.atValues.filter(function (option) {
                return option.id.toUpperCase().indexOf(queryText.toUpperCase()) !== -1;
            });
            return values.slice(0, 5);
        },
        mapValues(option) {
            option.user_id = option.id;
            option.id      = `@${option[this.mentionFrom]}`;
            return option;
        },
        mentionSelected(editor) {
            editor.conversion.for('downcast').attributeToElement({
                model            : 'mention',
                view             : (modelAttributeValue, viewWriter) => {
                    if (!modelAttributeValue) {
                        return;
                    }
                    const mention = {
                        ...modelAttributeValue,
                        id: modelAttributeValue.user_id
                    }
                    // Bus.$emit('mention', mention);
                    let thisVueComponent = editor.sourceElement.__vue__;
                    thisVueComponent.$emit('mention', mention);
                },
                converterPriority: 'high'
            });
        },
        addField(data){
            if (!this.editorInstance) return;
            this.editorInstance.model.change(writer => {
                const selection = this.editorInstance.model.document.selection;
                writer.insertText(data, selection.getFirstPosition());
            });
        }
    }

}

</script>

<style>
.ck-editor__editable {
    max-height: 200px;
}

.ck-editor__editable > ul {
    list-style-type: disc !important;
}

.ul-list-style-type > ul {
    list-style-type: disc !important;
}

</style>
